import React, { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, NavLink, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Lenis from "@studio-freight/lenis";
import { Phone, Menu, X, MapPin, Mail, Clock, ChevronRight, ChevronLeft, MessageCircle, ExternalLink } from "lucide-react";
import axios from "axios";
import { Toaster, toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Company Info
const companyInfo = {
  name: "DS Serramenti",
  tagline: "Cornici per la tua vita",
  description: "Fornitura e Posa: Serramenti, Zanzariere, Persiane, Tapparelle, Cassonetti, Porte Interne e Porte Blindate",
  address: "Monza e della Brianza, Milano, Italia",
  phone: "+39 329 127 9397",
  email: "infoserramenti03@gmail.com",
  whatsapp: "393291279397",
  tiktok: "https://www.tiktok.com/@ds.serramenti",
  instagram: "https://www.instagram.com/ds.serramenti",
  logo: "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/w2kixm36_IMG_0798.jpg"
};

// Product Categories with multiple images
const categories = [
  {
    id: "serramenti",
    name: "Serramenti",
    description: "Finestre e infissi di alta qualità per ogni ambiente",
    image: "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/h7t97dae_b609d1a0-38da-439f-baf7-4d135c38c661.JPG",
    images: [
      "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/h7t97dae_b609d1a0-38da-439f-baf7-4d135c38c661.JPG",
      "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/98izwjfu_75ada929-43f8-4c2b-9da1-b627b166a270.JPG"
    ],
    options: ["PVC", "Alluminio", "Legno"],
    allColors: true
  },
  {
    id: "persiane",
    name: "Persiane",
    description: "Protezione e stile per la tua casa",
    image: "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/bpjay62k_507335d4-8e43-4d5d-8441-cce18b4a3365.JPG",
    images: [
      "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/bpjay62k_507335d4-8e43-4d5d-8441-cce18b4a3365.JPG",
      "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/b00xi7me_aa3bcfe0-8ba4-418d-a8e6-f0c8473b8bcd.JPG",
      "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/qjy1rncm_c3170b62-92df-47f9-92b4-86d7bf4292af.JPG"
    ],
    allColors: true
  },
  {
    id: "porte-blindate",
    name: "Porte Blindate",
    description: "Sicurezza senza compromessi",
    image: "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/v1iu83bz_704a1c56-7e0d-4f60-8688-165ea7edf2fe.JPG",
    images: [
      "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/v1iu83bz_704a1c56-7e0d-4f60-8688-165ea7edf2fe.JPG",
      "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/8r8uhbee_6b36790b-b25e-4747-b1c3-373e391351bc.JPG",
      "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/g4t5d65l_3614601c-596a-47c5-841a-ac655b0acbc1.JPG"
    ],
    allColors: true
  },
  {
    id: "porte-interne",
    name: "Porte Interne",
    description: "Design elegante per ogni stanza",
    image: "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/lh18bcwi_c410ee20-46a3-49cb-9d4a-bbfd0accce50.JPG",
    images: [
      "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/lh18bcwi_c410ee20-46a3-49cb-9d4a-bbfd0accce50.JPG",
      "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/zx0vgiet_e2d2f221-98ce-4728-9900-eb2451e9907f.JPG",
      "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/1wastlqr_47b955ab-d172-4880-9f47-a69e9c712cd9.JPG"
    ],
    allColors: true
  },
  {
    id: "zanzariere",
    name: "Zanzariere",
    description: "Comfort e protezione tutto l'anno",
    image: "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/u5yeublf_dfa1d0ca-1d0a-45c8-a9bc-f855dd4b1d52.JPG",
    images: [
      "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/u5yeublf_dfa1d0ca-1d0a-45c8-a9bc-f855dd4b1d52.JPG",
      "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/x0t5genj_f53e544f-0838-41f2-a3db-b9cc36ca5390.JPG",
      "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/ecv6o2g5_43a75f12-f807-48a3-9af1-589de1c7283e.JPG"
    ],
    allColors: true
  },
  {
    id: "tapparelle",
    name: "Tapparelle",
    description: "Isolamento e privacy garantiti",
    image: "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/agdi7jeu_8b77058b-a36d-4204-b5de-92cd0e072aa2.JPG",
    images: [
      "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/agdi7jeu_8b77058b-a36d-4204-b5de-92cd0e072aa2.JPG",
      "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/i4ws9pr1_845bf979-dc17-4ed2-b1aa-ce56f9e1c35f.JPG",
      "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/nqa874cb_940079c5-d1bf-40f9-9683-a4cc191198a7.JPG"
    ],
    options: ["Alluminio coibentate", "PVC", "Acciaio"],
    allColors: true
  },
  {
    id: "cassonetti",
    name: "Cassonetti",
    description: "Soluzioni per avvolgibili e isolamento termico",
    image: "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/v494ew2t_fd4bf4c3-7ca1-49cf-ae7e-3b583c365bd7.JPG",
    images: [
      "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/v494ew2t_fd4bf4c3-7ca1-49cf-ae7e-3b583c365bd7.JPG",
      "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/eiv0eqiv_0cdf42cd-002b-4212-b5ce-ef3432057a2f.JPG",
      "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/29wiwevi_211d5870-e84a-47dd-96d3-278984b5345e.JPG",
      "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/wr1jsa7k_0cd09eb8-0a9d-4220-9001-e7cc8777aeef.JPG",
      "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/thackmvs_b4709b5a-5453-42b1-82cf-45ea4146c957.JPG"
    ],
    allColors: true
  },
  {
    id: "posa-clima",
    name: "Posa Clima",
    description: "Il sistema PosaClima è un metodo certificato e innovativo per l'installazione di serramenti, conforme alla norma UNI 11673-1, che garantisce elevato isolamento termico e acustico. A differenza della posa tradizionale, utilizza nastri autoespandenti, barriere vapore, schiume elastiche e controtelai termici per eliminare spifferi, muffe e condensa, offrendo spesso 10 anni di garanzia.",
    image: "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/fu65s6yz_4e25a43c-8922-482e-8f9d-d3b9818e4d91.jpeg",
    images: [
      "https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/fu65s6yz_4e25a43c-8922-482e-8f9d-d3b9818e4d91.jpeg"
    ]
  }
];

// Animation variants
const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.25, 0.46, 0.45, 0.94] } }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.1, delayChildren: 0.2 } }
};

// Smooth Scroll Provider
const SmoothScrollProvider = ({ children }) => {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: "vertical",
      gestureOrientation: "vertical",
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 2,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    return () => lenis.destroy();
  }, []);

  return children;
};

// Header Component
const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  const navItems = [
    { path: "/", label: "Home" },
    { path: "/prodotti", label: "Prodotti" },
    { path: "/chi-siamo", label: "Chi Siamo" },
    { path: "/contatti", label: "Contatti" }
  ];

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-white/95 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
      data-testid="header"
    >
      <div className="container-custom pl-4 md:pl-8">
        <div className="flex items-center justify-between h-20 md:h-24">
          <NavLink to="/" className="relative z-10" data-testid="logo-link">
            <div className={`flex items-center transition-colors ${scrolled ? 'text-black' : 'text-white'}`}>
              <span className="text-3xl md:text-4xl font-serif font-bold tracking-tight">
                <span className="italic">D</span>S
              </span>
              <span className={`hidden sm:block ml-3 text-xs uppercase tracking-[0.15em] border-l pl-3 leading-tight transition-colors ${scrolled ? 'text-zinc-600 border-zinc-300' : 'text-white/80 border-white/40'}`}>
                Serramenti<br/>e Infissi
              </span>
            </div>
          </NavLink>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-10" data-testid="desktop-nav">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `text-sm uppercase tracking-[0.2em] font-medium hover-underline transition-colors ${
                    scrolled
                      ? (isActive ? "text-black" : "text-zinc-600 hover:text-black")
                      : (isActive ? "text-white" : "text-white/80 hover:text-white")
                  }`
                }
                data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          {/* Contact Button */}
          <a
            href={`https://wa.me/${companyInfo.whatsapp}`}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden md:flex items-center gap-2 bg-black text-white px-6 py-3 text-sm uppercase tracking-wider hover:bg-zinc-800 transition-colors"
            data-testid="header-whatsapp-btn"
          >
            <MessageCircle size={16} />
            WhatsApp
          </a>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden relative z-10 p-2"
            data-testid="mobile-menu-btn"
            aria-label="Menu"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
            className="fixed inset-0 bg-white z-40 pt-24 md:hidden"
            data-testid="mobile-menu"
          >
            <nav className="container-custom flex flex-col gap-8 py-8">
              {navItems.map((item, index) => (
                <motion.div
                  key={item.path}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: index * 0.1 }}
                >
                  <NavLink
                    to={item.path}
                    className={({ isActive }) =>
                      `text-3xl font-serif ${isActive ? "text-black" : "text-zinc-400"}`
                    }
                    data-testid={`mobile-nav-${item.label.toLowerCase().replace(' ', '-')}`}
                  >
                    {item.label}
                  </NavLink>
                </motion.div>
              ))}
              <motion.a
                href={`https://wa.me/${companyInfo.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.4 }}
                className="flex items-center gap-3 mt-8 text-lg"
                data-testid="mobile-whatsapp-link"
              >
                <MessageCircle size={24} />
                Contattaci su WhatsApp
              </motion.a>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

// Footer Component
const Footer = () => {
  return (
    <footer className="bg-zinc-950 text-white py-16 md:py-24" data-testid="footer">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
          {/* Logo & Description */}
          <div className="md:col-span-2">
            <img 
              src={companyInfo.logo} 
              alt={companyInfo.name}
              className="h-16 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-zinc-400 max-w-md leading-relaxed">
              {companyInfo.description}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm uppercase tracking-widest mb-6 text-zinc-500">Navigazione</h4>
            <ul className="space-y-3">
              {["Home", "Prodotti", "Chi Siamo", "Contatti"].map((item) => (
                <li key={item}>
                  <NavLink
                    to={item === "Home" ? "/" : `/${item.toLowerCase().replace(' ', '-')}`}
                    className="text-zinc-400 hover:text-white transition-colors hover-underline"
                    data-testid={`footer-link-${item.toLowerCase().replace(' ', '-')}`}
                  >
                    {item}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-sm uppercase tracking-widest mb-6 text-zinc-500">Contatti</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-zinc-400">
                <MapPin size={18} className="mt-1 flex-shrink-0" />
                <span>{companyInfo.address}</span>
              </li>
              <li>
                <a 
                  href={`tel:${companyInfo.phone}`}
                  className="flex items-center gap-3 text-zinc-400 hover:text-white transition-colors"
                  data-testid="footer-phone"
                >
                  <Phone size={18} />
                  {companyInfo.phone}
                </a>
              </li>
              <li>
                <a 
                  href={`mailto:${companyInfo.email}`}
                  className="flex items-center gap-3 text-zinc-400 hover:text-white transition-colors"
                  data-testid="footer-email"
                >
                  <Mail size={18} />
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-zinc-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-center md:text-left">
            <p className="text-zinc-500 text-sm">
              © {new Date().getFullYear()} {companyInfo.name}. Tutti i diritti riservati.
            </p>
            <p className="text-zinc-600 text-xs mt-1">
              P.IVA: 14553740961
            </p>
          </div>
          <div className="flex items-center gap-6">
            <a
              href={companyInfo.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="text-zinc-500 hover:text-white transition-colors flex items-center gap-2"
              data-testid="footer-instagram"
            >
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
              Instagram
            </a>
            <a
              href={companyInfo.tiktok}
              target="_blank"
              rel="noopener noreferrer"
              className="text-zinc-500 hover:text-white transition-colors flex items-center gap-2"
              data-testid="footer-tiktok"
            >
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
              </svg>
              TikTok
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

// WhatsApp Floating Button
const WhatsAppButton = () => {
  return (
    <a
      href={`https://wa.me/${companyInfo.whatsapp}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:scale-110 transition-transform duration-300"
      data-testid="whatsapp-floating-btn"
      aria-label="Contattaci su WhatsApp"
    >
      <svg className="w-7 h-7" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
    </a>
  );
};

// Home Page
const HomePage = () => {
  return (
    <main data-testid="home-page">
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden" data-testid="hero-section">
        <div className="absolute inset-0">
          <img
            src="https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/2l3fwzrb_046efeed-fdf7-42cf-aa29-300eb078af54.jpeg"
            alt="Serramenti moderni"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />
        </div>
        
        <motion.div 
          className="relative z-10 text-center text-white px-6"
          initial="hidden"
          animate="visible"
          variants={staggerContainer}
        >
          <motion.p 
            className="text-sm uppercase tracking-[0.3em] mb-6 text-zinc-300"
            variants={fadeInUp}
          >
            {companyInfo.name}
          </motion.p>
          <motion.h1 
            className="text-5xl md:text-7xl lg:text-8xl font-serif mb-8"
            variants={fadeInUp}
          >
            <span className="italic">Cornici</span> per la tua vita
          </motion.h1>
          <motion.p 
            className="text-lg md:text-xl text-zinc-200 max-w-2xl mx-auto mb-10"
            variants={fadeInUp}
          >
            Eccellenza italiana in serramenti, porte e soluzioni per la tua casa
          </motion.p>
          <motion.div 
            className="flex flex-col sm:flex-row gap-4 justify-center"
            variants={fadeInUp}
          >
            <NavLink
              to="/prodotti"
              className="bg-white text-black px-8 py-4 text-sm uppercase tracking-widest hover:bg-zinc-100 transition-colors"
              data-testid="hero-products-btn"
            >
              Scopri i Prodotti
            </NavLink>
            <NavLink
              to="/contatti"
              className="border border-white text-white px-8 py-4 text-sm uppercase tracking-widest hover:bg-white hover:text-black transition-colors"
              data-testid="hero-contact-btn"
            >
              Richiedi Preventivo
            </NavLink>
          </motion.div>
        </motion.div>

        <motion.div 
          className="absolute bottom-10 left-1/2 -translate-x-1/2"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.5 }}
        >
          <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
            <motion.div 
              className="w-1 h-2 bg-white rounded-full mt-2"
              animate={{ y: [0, 12, 0] }}
              transition={{ duration: 1.5, repeat: Infinity }}
            />
          </div>
        </motion.div>
      </section>

      {/* Intro Section */}
      <section className="py-24 md:py-32" data-testid="intro-section">
        <div className="container-custom">
          <motion.div 
            className="max-w-4xl mx-auto text-center"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <p className="text-sm uppercase tracking-[0.3em] text-zinc-500 mb-6">Dal cuore della Brianza</p>
            <h2 className="text-4xl md:text-5xl font-serif mb-8">
              Design <span className="italic">senza confini</span>
            </h2>
            <p className="text-lg text-zinc-600 leading-relaxed">
              Da oltre un decennio, DS Serramenti rappresenta l'eccellenza italiana nel settore dei 
              serramenti e delle soluzioni per l'abitare. Ogni prodotto è selezionato con cura per 
              garantire qualità, durabilità e un design che valorizza ogni ambiente.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Featured Categories */}
      <section className="py-16 md:py-24 bg-zinc-50" data-testid="featured-categories">
        <div className="container-custom">
          <motion.div 
            className="flex flex-col md:flex-row justify-between items-start md:items-end mb-12 md:mb-16 gap-4"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            <div>
              <p className="text-sm uppercase tracking-[0.3em] text-zinc-500 mb-4">I Nostri Prodotti</p>
              <h2 className="text-4xl md:text-5xl font-serif">
                Soluzioni per ogni <span className="italic">esigenza</span>
              </h2>
            </div>
            <NavLink
              to="/prodotti"
              className="group flex items-center gap-2 text-sm uppercase tracking-widest hover:gap-4 transition-all"
              data-testid="view-all-products-link"
            >
              Vedi Tutti
              <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </NavLink>
          </motion.div>

          <motion.div 
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {categories.slice(0, 6).map((category, index) => (
              <motion.div
                key={category.id}
                variants={fadeInUp}
                className={`group relative overflow-hidden bg-white ${
                  index === 0 ? "md:col-span-2 md:row-span-2" : ""
                }`}
                data-testid={`category-card-${category.id}`}
              >
                <div className={`img-zoom ${index === 0 ? "aspect-square md:aspect-auto md:h-full" : "aspect-[4/3]"}`}>
                  <img
                    src={category.image}
                    alt={category.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                  <h3 className="text-2xl md:text-3xl font-serif text-white mb-2">{category.name}</h3>
                  <p className="text-zinc-300 text-sm mb-4">{category.description}</p>
                  <NavLink
                    to="/prodotti"
                    className="inline-flex items-center gap-2 text-white text-sm uppercase tracking-wider group-hover:gap-3 transition-all"
                    data-testid={`category-link-${category.id}`}
                  >
                    Scopri
                    <ChevronRight size={14} />
                  </NavLink>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="dark-section grain-effect py-24 md:py-32" data-testid="stats-section">
        <div className="container-custom">
          <motion.div 
            className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {[
              { value: "10+", label: "Anni di Esperienza" },
              { value: "500+", label: "Progetti Completati" },
              { value: "100%", label: "Clienti Soddisfatti" },
              { value: "24h", label: "Assistenza" }
            ].map((stat, index) => (
              <motion.div 
                key={index}
                className="text-center"
                variants={fadeInUp}
              >
                <p className="text-5xl md:text-6xl font-serif mb-2">{stat.value}</p>
                <p className="text-zinc-400 text-sm uppercase tracking-wider">{stat.label}</p>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Reviews Section */}
      <section className="py-24 md:py-32 bg-zinc-50" data-testid="reviews-section">
        <div className="container-custom">
          <motion.div 
            className="text-center mb-16"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <p className="text-sm uppercase tracking-[0.3em] text-zinc-500 mb-4">Cosa Dicono di Noi</p>
            <h2 className="text-4xl md:text-5xl font-serif">
              Le <span className="italic">Recensioni</span> dei Clienti
            </h2>
          </motion.div>

          <motion.div 
            className="grid grid-cols-1 md:grid-cols-3 gap-8"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {[
              {
                name: "Ermal Metushaj",
                rating: 5,
                text: "Ottimo servizio, consigliatissimo!",
                date: "2026-03-09",
                isReal: true
              },
              {
                name: "Marco B.",
                rating: 5,
                text: "Professionali e puntuali. Hanno sostituito tutte le finestre di casa in tempi record. Qualità eccellente e ottimo rapporto qualità-prezzo.",
                date: "2025-12-15"
              },
              {
                name: "Laura R.",
                rating: 5,
                text: "Installazione impeccabile delle porte blindate. Team competente e disponibile. Consiglio vivamente DS Serramenti per serietà e professionalità.",
                date: "2025-11-20"
              },
              {
                name: "Giuseppe M.",
                rating: 5,
                text: "Finestre in PVC di alta qualità. Il sistema PosaClima ha eliminato completamente gli spifferi. Casa più calda e bollette più basse!",
                date: "2025-10-08"
              }
            ].map((review, index) => (
              <motion.div 
                key={index}
                variants={fadeInUp}
                className="bg-white p-8 shadow-sm"
                data-testid={`review-${index}`}
              >
                <div className="flex gap-1 mb-4">
                  {[...Array(review.rating)].map((_, i) => (
                    <svg key={i} className="w-5 h-5 text-yellow-400 fill-current" viewBox="0 0 20 20">
                      <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z"/>
                    </svg>
                  ))}
                </div>
                <p className="text-zinc-600 mb-6 leading-relaxed">"{review.text}"</p>
                <div className="flex items-center justify-between">
                  <p className="font-medium">{review.name}</p>
                  <p className="text-zinc-400 text-sm">{new Date(review.date).toLocaleDateString('it-IT')}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>

          <motion.div 
            className="text-center mt-12"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            <a
              href="https://g.page/r/CXaRVc4c7ur9EAE/review"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-black text-white px-8 py-4 text-sm uppercase tracking-widest hover:bg-zinc-800 transition-colors"
              data-testid="write-review-btn"
            >
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              Lascia una Recensione
            </a>
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 md:py-32" data-testid="cta-section">
        <div className="container-custom">
          <motion.div 
            className="max-w-4xl mx-auto text-center"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif mb-8">
              Pronto a trasformare la tua <span className="italic">casa</span>?
            </h2>
            <p className="text-lg text-zinc-600 mb-10 max-w-2xl mx-auto">
              Contattaci per una consulenza gratuita e un preventivo personalizzato. 
              I nostri esperti sono pronti ad aiutarti.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <NavLink
                to="/contatti"
                className="bg-black text-white px-10 py-4 text-sm uppercase tracking-widest hover:bg-zinc-800 transition-colors"
                data-testid="cta-contact-btn"
              >
                Richiedi Preventivo
              </NavLink>
              <a
                href={`https://wa.me/${companyInfo.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                className="border border-black text-black px-10 py-4 text-sm uppercase tracking-widest hover:bg-black hover:text-white transition-colors flex items-center justify-center gap-2"
                data-testid="cta-whatsapp-btn"
              >
                <MessageCircle size={18} />
                WhatsApp
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </main>
  );
};

// Image Gallery Modal Component
const ImageGalleryModal = ({ category, isOpen, onClose }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  
  if (!isOpen || !category) return null;
  
  const images = category.images || [category.image];
  
  const nextImage = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };
  
  const prevImage = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4"
          onClick={onClose}
          data-testid="gallery-modal"
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            className="relative w-full max-w-5xl"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={onClose}
              className="absolute -top-12 right-0 text-white hover:text-zinc-300 transition-colors z-10"
              data-testid="gallery-close-btn"
            >
              <X size={32} />
            </button>
            
            {/* Category Title */}
            <div className="absolute -top-12 left-0 text-white">
              <h3 className="text-2xl font-serif">{category.name}</h3>
            </div>
            
            {/* Main Image */}
            <div className="relative aspect-[4/3] bg-zinc-900 overflow-hidden">
              <AnimatePresence mode="wait">
                <motion.img
                  key={currentIndex}
                  src={images[currentIndex]}
                  alt={`${category.name} - ${currentIndex + 1}`}
                  className="w-full h-full object-contain"
                  initial={{ opacity: 0, x: 50 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -50 }}
                  transition={{ duration: 0.3 }}
                />
              </AnimatePresence>
              
              {/* Navigation Arrows */}
              {images.length > 1 && (
                <>
                  <button
                    onClick={prevImage}
                    className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-white/30 p-3 rounded-full transition-colors"
                    data-testid="gallery-prev-btn"
                  >
                    <ChevronLeft size={24} className="text-white" />
                  </button>
                  <button
                    onClick={nextImage}
                    className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-white/30 p-3 rounded-full transition-colors"
                    data-testid="gallery-next-btn"
                  >
                    <ChevronRight size={24} className="text-white" />
                  </button>
                </>
              )}
            </div>
            
            {/* Image Counter & Thumbnails */}
            <div className="mt-4 flex items-center justify-between">
              <p className="text-white text-sm">
                {currentIndex + 1} / {images.length}
              </p>
              
              {/* Thumbnail Navigation */}
              {images.length > 1 && (
                <div className="flex gap-2">
                  {images.map((img, idx) => (
                    <button
                      key={idx}
                      onClick={() => setCurrentIndex(idx)}
                      className={`w-16 h-12 overflow-hidden border-2 transition-all ${
                        idx === currentIndex ? "border-white" : "border-transparent opacity-50 hover:opacity-100"
                      }`}
                      data-testid={`gallery-thumb-${idx}`}
                    >
                      <img src={img} alt="" className="w-full h-full object-cover" />
                    </button>
                  ))}
                </div>
              )}
            </div>

            {/* Material Options */}
            {category.options && category.options.length > 0 && (
              <div className="mt-4 p-4 bg-white/10 rounded">
                <p className="text-zinc-400 text-xs uppercase tracking-wider mb-3">Materiali disponibili:</p>
                <div className="flex flex-wrap gap-2">
                  {category.options.map((option, idx) => (
                    <span 
                      key={idx}
                      className="px-4 py-2 bg-white/20 text-white text-sm rounded"
                    >
                      {option}
                    </span>
                  ))}
                </div>
              </div>
            )}

            {/* All Colors Available */}
            {category.allColors && (
              <div className="mt-4 p-4 bg-white/10 rounded">
                <p className="text-zinc-400 text-xs uppercase tracking-wider mb-3">Colori disponibili:</p>
                <div className="flex items-center gap-3">
                  <div className="flex -space-x-1">
                    <span className="w-6 h-6 rounded-full bg-white border-2 border-zinc-600"></span>
                    <span className="w-6 h-6 rounded-full bg-zinc-800 border-2 border-zinc-600"></span>
                    <span className="w-6 h-6 rounded-full bg-amber-700 border-2 border-zinc-600"></span>
                    <span className="w-6 h-6 rounded-full bg-green-800 border-2 border-zinc-600"></span>
                    <span className="w-6 h-6 rounded-full bg-blue-900 border-2 border-zinc-600"></span>
                    <span className="w-6 h-6 rounded-full bg-red-800 border-2 border-zinc-600"></span>
                  </div>
                  <span className="text-white text-sm">Tutte le colorazioni RAL</span>
                </div>
              </div>
            )}
            
            {/* Contact Button */}
            <div className="mt-6 text-center">
              <NavLink
                to="/contatti"
                onClick={onClose}
                className="inline-flex items-center gap-2 bg-white text-black px-8 py-3 text-sm uppercase tracking-wider hover:bg-zinc-100 transition-colors"
                data-testid="gallery-contact-btn"
              >
                Richiedi Info
                <ChevronRight size={16} />
              </NavLink>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

// Products Page
const ProductsPage = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);

  const openGallery = (category) => {
    setSelectedCategory(category);
    setIsGalleryOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeGallery = () => {
    setIsGalleryOpen(false);
    setSelectedCategory(null);
    document.body.style.overflow = 'unset';
  };

  return (
    <main className="pt-24 md:pt-32" data-testid="products-page">
      {/* Image Gallery Modal */}
      <ImageGalleryModal 
        category={selectedCategory} 
        isOpen={isGalleryOpen} 
        onClose={closeGallery} 
      />

      {/* Page Header */}
      <section className="py-16 md:py-24">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <p className="text-sm uppercase tracking-[0.3em] text-zinc-500 mb-4">La Nostra Collezione</p>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif mb-6">
              I Nostri <span className="italic">Prodotti</span>
            </h1>
            <p className="text-lg text-zinc-600 max-w-2xl">
              Scopri la nostra gamma completa di serramenti, porte e soluzioni per la tua casa. 
              Qualità italiana, design senza confini.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="pb-24 md:pb-32">
        <div className="container-custom">
          <motion.div 
            className="grid grid-cols-1 md:grid-cols-2 gap-8"
            variants={staggerContainer}
            initial="hidden"
            animate="visible"
          >
            {categories.map((category, index) => (
              <motion.div
                key={category.id}
                variants={fadeInUp}
                className="group cursor-pointer"
                data-testid={`product-${category.id}`}
                onClick={() => openGallery(category)}
              >
                <div className="relative overflow-hidden bg-zinc-100 aspect-[4/3] mb-6 img-zoom">
                  <img
                    src={category.image}
                    alt={category.name}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-500 flex items-center justify-center">
                    <span className="text-white text-sm uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-opacity bg-black/50 px-6 py-3">
                      Vedi Galleria ({category.images?.length || 1} foto)
                    </span>
                  </div>
                </div>
                <h2 className="text-2xl md:text-3xl font-serif mb-3">{category.name}</h2>
                <p className="text-zinc-600 mb-4">{category.description}</p>
                {/* Material Options */}
                {category.options && category.options.length > 0 && (
                  <div className="mb-4 flex flex-wrap gap-2">
                    {category.options.map((option, idx) => (
                      <span 
                        key={idx}
                        className="px-3 py-1 bg-zinc-100 text-zinc-700 text-xs uppercase tracking-wider"
                      >
                        {option}
                      </span>
                    ))}
                  </div>
                )}
                {/* All Colors Badge */}
                {category.allColors && (
                  <div className="mb-4 flex items-center gap-2">
                    <div className="flex -space-x-1">
                      <span className="w-4 h-4 rounded-full bg-white border border-zinc-300"></span>
                      <span className="w-4 h-4 rounded-full bg-zinc-800 border border-zinc-300"></span>
                      <span className="w-4 h-4 rounded-full bg-amber-700 border border-zinc-300"></span>
                      <span className="w-4 h-4 rounded-full bg-green-800 border border-zinc-300"></span>
                    </div>
                    <span className="text-xs text-zinc-500 uppercase tracking-wider">Tutte le colorazioni</span>
                  </div>
                )}
                <button
                  className="inline-flex items-center gap-2 text-sm uppercase tracking-wider hover:gap-3 transition-all border-b border-black pb-1"
                  data-testid={`product-gallery-btn-${category.id}`}
                >
                  Vedi Foto
                  <ChevronRight size={14} />
                </button>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="dark-section grain-effect py-24 md:py-32" data-testid="products-cta">
        <div className="container-custom">
          <motion.div 
            className="max-w-3xl mx-auto text-center"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl md:text-5xl font-serif mb-6">
              Non trovi quello che cerchi?
            </h2>
            <p className="text-zinc-400 mb-8">
              Contattaci per soluzioni personalizzate. Realizziamo prodotti su misura per ogni esigenza.
            </p>
            <NavLink
              to="/contatti"
              className="inline-block bg-white text-black px-10 py-4 text-sm uppercase tracking-widest hover:bg-zinc-100 transition-colors"
              data-testid="products-contact-btn"
            >
              Contattaci
            </NavLink>
          </motion.div>
        </div>
      </section>
    </main>
  );
};

// About Page
const AboutPage = () => {
  return (
    <main className="pt-24 md:pt-32" data-testid="about-page">
      {/* Hero */}
      <section className="py-16 md:py-24">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-4xl"
          >
            <p className="text-sm uppercase tracking-[0.3em] text-zinc-500 mb-4">La Nostra Storia</p>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif mb-8">
              Chi <span className="italic">Siamo</span>
            </h1>
            <p className="text-xl text-zinc-600 leading-relaxed">
              DS Serramenti nasce dalla passione per l'eccellenza e dalla volontà di offrire 
              ai nostri clienti solo il meglio nel settore dei serramenti e delle soluzioni 
              per l'abitare.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Image Section */}
      <section className="py-8">
        <div className="container-custom">
          <motion.div 
            className="relative aspect-[21/9] overflow-hidden"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
          >
            <img
              src="https://customer-assets.emergentagent.com/job_digital-builder-11/artifacts/d8tvnwt3_IMG_4313.JPG"
              alt="DS Serramenti"
              className="w-full h-full object-cover"
            />
          </motion.div>
        </div>
      </section>

      {/* Values */}
      <section className="py-24 md:py-32">
        <div className="container-custom">
          <motion.div 
            className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            <div>
              <p className="text-sm uppercase tracking-[0.3em] text-zinc-500 mb-4">I Nostri Valori</p>
              <h2 className="text-4xl md:text-5xl font-serif mb-8">
                Qualità, <span className="italic">Passione</span>, Professionalità
              </h2>
              <p className="text-zinc-600 leading-relaxed mb-6">
                Ogni progetto che realizziamo è il risultato di anni di esperienza, dedizione 
                e attenzione al dettaglio. Lavoriamo solo con i migliori fornitori e materiali 
                per garantire prodotti che durano nel tempo.
              </p>
              <p className="text-zinc-600 leading-relaxed">
                Il nostro team di esperti è sempre pronto ad ascoltare le tue esigenze e a 
                trovare la soluzione perfetta per la tua casa. Dalla consulenza iniziale 
                all'installazione finale, ti accompagniamo in ogni fase del progetto.
              </p>
            </div>
            <motion.div 
              className="grid grid-cols-2 gap-6"
              variants={staggerContainer}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
            >
              {[
                { title: "Qualità", desc: "Solo materiali premium selezionati" },
                { title: "Esperienza", desc: "Oltre 10 anni nel settore" },
                { title: "Servizio", desc: "Assistenza completa pre e post vendita" },
                { title: "Garanzia", desc: "Prodotti garantiti nel tempo" }
              ].map((value, index) => (
                <motion.div 
                  key={index}
                  variants={fadeInUp}
                  className="p-6 bg-zinc-50 border border-zinc-100"
                  data-testid={`value-${index}`}
                >
                  <h3 className="text-xl font-serif mb-2">{value.title}</h3>
                  <p className="text-zinc-600 text-sm">{value.desc}</p>
                </motion.div>
              ))}
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Location */}
      <section className="dark-section grain-effect py-24 md:py-32" data-testid="location-section">
        <div className="container-custom">
          <motion.div 
            className="text-center max-w-3xl mx-auto"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            <MapPin className="mx-auto mb-6" size={32} />
            <h2 className="text-4xl md:text-5xl font-serif mb-6">
              Monza e della Brianza
            </h2>
            <p className="text-zinc-400 text-lg mb-8">
              Situati nel cuore della Lombardia, serviamo clienti in tutta la provincia di 
              Milano e Brianza. Vieni a trovarci per scoprire la nostra showroom.
            </p>
            <NavLink
              to="/contatti"
              className="inline-block bg-white text-black px-10 py-4 text-sm uppercase tracking-widest hover:bg-zinc-100 transition-colors"
              data-testid="about-contact-btn"
            >
              Contattaci
            </NavLink>
          </motion.div>
        </div>
      </section>
    </main>
  );
};

// Contact Page
const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    message: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await axios.post(`${API}/contact`, formData);
      toast.success("Messaggio inviato con successo! Ti contatteremo presto.");
      setFormData({ name: "", email: "", phone: "", service: "", message: "" });
    } catch (error) {
      toast.error("Errore nell'invio del messaggio. Riprova più tardi.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="pt-24 md:pt-32" data-testid="contact-page">
      {/* Header */}
      <section className="py-16 md:py-24">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-4xl"
          >
            <p className="text-sm uppercase tracking-[0.3em] text-zinc-500 mb-4">Parliamo</p>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif mb-8">
              <span className="italic">Contattaci</span>
            </h1>
            <p className="text-xl text-zinc-600">
              Hai un progetto in mente? Siamo qui per aiutarti. Compila il modulo o 
              contattaci direttamente.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="pb-24 md:pb-32">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Contact Form */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <h2 className="text-2xl font-serif mb-8">Richiedi un Preventivo</h2>
              <form onSubmit={handleSubmit} className="space-y-6" data-testid="contact-form">
                <div>
                  <input
                    type="text"
                    name="name"
                    placeholder="Nome e Cognome *"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full bg-transparent border-b border-zinc-300 px-0 py-4 focus:border-black focus:outline-none transition-colors placeholder:text-zinc-400"
                    data-testid="input-name"
                  />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email *"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full bg-transparent border-b border-zinc-300 px-0 py-4 focus:border-black focus:outline-none transition-colors placeholder:text-zinc-400"
                    data-testid="input-email"
                  />
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Telefono"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full bg-transparent border-b border-zinc-300 px-0 py-4 focus:border-black focus:outline-none transition-colors placeholder:text-zinc-400"
                    data-testid="input-phone"
                  />
                </div>
                <div>
                  <select
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    className="w-full bg-transparent border-b border-zinc-300 px-0 py-4 focus:border-black focus:outline-none transition-colors text-zinc-400"
                    data-testid="input-service"
                  >
                    <option value="">Seleziona un servizio</option>
                    {categories.map(cat => (
                      <option key={cat.id} value={cat.id}>{cat.name}</option>
                    ))}
                    <option value="altro">Altro</option>
                  </select>
                </div>
                <div>
                  <textarea
                    name="message"
                    placeholder="Il tuo messaggio *"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows={5}
                    className="w-full bg-transparent border-b border-zinc-300 px-0 py-4 focus:border-black focus:outline-none transition-colors placeholder:text-zinc-400 resize-none"
                    data-testid="input-message"
                  />
                </div>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="bg-black text-white px-10 py-4 text-sm uppercase tracking-widest hover:bg-zinc-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed w-full md:w-auto"
                  data-testid="submit-btn"
                >
                  {isSubmitting ? "Invio in corso..." : "Invia Richiesta"}
                </button>
              </form>
            </motion.div>

            {/* Contact Info */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="lg:pl-16"
            >
              <h2 className="text-2xl font-serif mb-8">Informazioni di Contatto</h2>
              
              <div className="space-y-8">
                <div className="flex gap-4">
                  <MapPin size={24} className="flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-medium mb-1">Indirizzo</h3>
                    <p className="text-zinc-600">{companyInfo.address}</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <Phone size={24} className="flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-medium mb-1">Telefono</h3>
                    <a 
                      href={`tel:${companyInfo.phone}`}
                      className="text-zinc-600 hover:text-black transition-colors"
                      data-testid="contact-phone"
                    >
                      {companyInfo.phone}
                    </a>
                  </div>
                </div>

                <div className="flex gap-4">
                  <Mail size={24} className="flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-medium mb-1">Email</h3>
                    <a 
                      href={`mailto:${companyInfo.email}`}
                      className="text-zinc-600 hover:text-black transition-colors"
                      data-testid="contact-email"
                    >
                      {companyInfo.email}
                    </a>
                  </div>
                </div>

                <div className="flex gap-4">
                  <Clock size={24} className="flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-medium mb-1">Orari</h3>
                    <p className="text-zinc-600">
                      Lun - Ven: 9:00 - 18:00<br />
                      Sab: 9:00 - 12:00
                    </p>
                  </div>
                </div>
              </div>

              {/* Social & Quick Contact */}
              <div className="mt-12 pt-8 border-t border-zinc-200">
                <h3 className="font-medium mb-4">Contatto Rapido</h3>
                <div className="flex flex-col sm:flex-row gap-4">
                  <a
                    href={`https://wa.me/${companyInfo.whatsapp}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center gap-2 bg-[#25D366] text-white px-6 py-3 hover:bg-[#20bd5a] transition-colors"
                    data-testid="contact-whatsapp"
                  >
                    <MessageCircle size={18} />
                    WhatsApp
                  </a>
                  <a
                    href={companyInfo.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center gap-2 bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500 text-white px-6 py-3 hover:opacity-90 transition-opacity"
                    data-testid="contact-instagram"
                  >
                    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                    </svg>
                    Instagram
                  </a>
                  <a
                    href={companyInfo.tiktok}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center gap-2 bg-black text-white px-6 py-3 hover:bg-zinc-800 transition-colors"
                    data-testid="contact-tiktok"
                  >
                    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                    </svg>
                    TikTok
                  </a>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </main>
  );
};

// Layout Component
const Layout = ({ children }) => {
  const location = useLocation();
  
  return (
    <>
      <Header />
      <AnimatePresence mode="wait">
        <motion.div
          key={location.pathname}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          {children}
        </motion.div>
      </AnimatePresence>
      <Footer />
      <WhatsAppButton />
      <div className="noise-overlay" />
    </>
  );
};

// Main App Component
function App() {
  return (
    <SmoothScrollProvider>
      <div className="App">
        <Toaster position="top-right" richColors />
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/prodotti" element={<ProductsPage />} />
              <Route path="/chi-siamo" element={<AboutPage />} />
              <Route path="/contatti" element={<ContactPage />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </div>
    </SmoothScrollProvider>
  );
}

export default App;
